<template>
	<div class="opening-app">
		<div v-if="!error">
			<p>Åbner Arriva Tog appen...</p>
			<p>Hvis appen ikke åbner automatisk indenfor 5 sekunder, <a ref="button" href="#" @click="onClick">klik her.</a></p>
			<p v-show="clicked && !redirected">Omdirigerer<span ref="dots"></span></p>
		</div>
		<div v-else>
			<h1>Ups! Noget gik galt...</h1>
			<p>Der skete en kritisk fejl.</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OpenApp',
	data() {
		return {
			os: '',
			isCompatibleDevice: false,
			downloadLink: '',
			clicked: false,
			redirected: false,
			error: false,

			ios: null,
			android: null,
			web: null,
		}
	},
	mounted() {
		const params = new URLSearchParams(window.location.search)
		this.ios = decodeURIComponent(params.get('ios'))
		this.android = decodeURIComponent(params.get('android'))
		this.web = decodeURIComponent(params.get('web'))

		if (!params.has('ios') || !params.has('android') || !params.has('web')) return (this.error = true)

		this.getOS()

		if (this.isCompatibleDevice) {
			const dotInterval = setInterval(() => {
				const el = this.$refs.dots
				if (el.innerHTML.length > 2) el.innerHTML = ''
				else el.innerHTML += '.'
			}, 500)

			this.$once('hook:destroyed', () => {
				clearInterval(dotInterval)
			})
		}

		document.addEventListener('visibilitychange', this.onVisibilityChange)
		this.$once('hook:destroyed', () => {
			document.removeEventListener('visibilitychange', this.onVisibilityChange)
		})
	},
	methods: {
		onVisibilityChange() {
			this.redirected = true
		},
		onClick() {
			if (this.os === 'iOS') {
				window.location.replace(this.ios)

				/* Redirect to app store */
				setTimeout(() => {
					if (!this.redirected) return window.location.replace(this.downloadLink)
					return
				}, 5000)
			} else if (this.os === 'Android') {
				window.location.replace(this.android)
			} else {
				window.location.replace(this.web)
			}
			this.clicked = true
		},
		getOS() {
			const userAgent = window.navigator.userAgent,
				platform = window.navigator.platform || window.navigator.userAgentData.platform,
				macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
				windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
				iosPlatforms = ['iPhone', 'iPad', 'iPod']
			let isAndroid = false,
				isIOS = false

			if (macosPlatforms.indexOf(platform) !== -1) {
				this.os = 'Mac OS'
			} else if (iosPlatforms.indexOf(platform) !== -1) {
				/* iOS */
				this.os = 'iOS'
				this.isCompatibleDevice = true
				isIOS = true
				this.downloadLink = 'https://apps.apple.com/us/app/arriva-tog/id1335935955'
			} else if (windowsPlatforms.indexOf(platform) !== -1) {
				this.os = 'Windows'
			} else if (/Android/.test(userAgent)) {
				/* Android */
				this.os = 'Android'
				this.isCompatibleDevice = true
				isAndroid = true
				this.downloadLink = 'intent:#Intent;package=dk.arriva.mobilbillet;end;'
			} else if (/Linux/.test(platform)) {
				this.os = 'Linux'
			} else {
				return console.warn('OS could not be detected.')
			}

			if (isAndroid) {
				window.location.replace(this.android)
			} else if (isIOS) {
				window.location.replace(this.ios)

				/* Redirect to app store */
				setTimeout(() => {
					if (!this.redirected) return window.location.replace(this.downloadLink)
					return
				}, 5000)
			} else {
				/* Redirect to web */
				window.location.replace(this.web)
			}
		},
	},
}
</script>

<style lang="scss">
html,
body {
	min-height: calc(100vh - 70px);
	width: 100%;
	background: #00becd;
}
.opening-app {
	color: #fff;
	p,
	span,
	a {
		color: inherit;
	}
}
</style>
